import SideMenu from '@/containers/side-menu/SideMenu.vue'
import WalletBonus from '@/pages/wallet-bonus/WalletBonus.vue'

export default {
  path: '/wallet-bonus',
  name: 'WalletBonus',
  components: {
    mainContent: WalletBonus,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'wallet-bonus'
    },
    breadcrumb: {
      title: 'Crédito em Carteira',
      paths: [
        { title: 'Carteira' },
        { title: 'Bonus' },
      ]
    }
  }
}